import { Col, Row } from "react-bootstrap";
import Pageheader from "../../components/pageheader/pageheader";
import {TracesList} from "./components/traces-list/TracesList.tsx";
import TraceDetails from "./components/traces-list/components/TraceDetails.tsx";
import { useDocumentTitle } from "@/shared/hooks/useDocumentTitle";


const TracesPage = () => {
  useDocumentTitle("Tracer");

  return (
    <div className="px-3">
      <Pageheader
        title="Tracer"
        heading="Tracer"
        active="Tracer"
      />
      <Row>
        <Col xl={12}>
            <TraceDetails />
            <TracesList />
        </Col>
      </Row>
    </div>
  );
};


export default (TracesPage);
